/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useReducer, useContext } from 'react';
import * as authActions from './actions';
import authReducer, { initState } from './reducer';
import { AuthState } from './types';
import { Dispatch } from '../types';

const AuthContext = createContext<[AuthState, Dispatch]>([initState, () => {}]);

export const AuthProvider: React.FC = ({ children }) => {
  const value = useReducer(authReducer, initState);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = (): [AuthState, Record<string, any>] => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('[Auth] useAuth must be used within AuthProvider.');
  }
  const [state, dispatch] = context;

  const dispatchActions = {
    login: authActions.login(dispatch),
    register: authActions.register(dispatch),
    logout: authActions.logout(dispatch),
    resumeSession: authActions.resumeSession(dispatch),
  };

  return [state, dispatchActions];
};

export default useAuth;
